// client/src/research/ResearchDescription.js
import { Typography } from '@mui/material';

function ResearchDescription({ description }) {
  
  // If no description, don't render anything
  if (!description || description.trim() === '') return null;

  return (
    <Typography 
      variant="body1" 
      sx={{ 
        mb: 3, 
        fontStyle: 'italic',
        lineHeight: 1.6,
        color: 'var(--light-grey)',
        whiteSpace: 'pre-wrap', // Preserve line breaks
        textAlign: 'center'
      }}
    >
      {description}
    </Typography>
  );
}

export default ResearchDescription;